(() => {
  function initFeaturedDots(root) {
    const component = root.querySelector('slider-component');
    const dotsEl = root.querySelector('[data-zaoud-fc-dots]');
    const currentEl = root.querySelector('.slider-counter--current');
    const totalEl = root.querySelector('.slider-counter--total');

    if (!component || !dotsEl || !currentEl || !totalEl) return;

    const rebuild = () => {
      const total = Math.max(0, parseInt(totalEl.textContent, 10) || 0);
      if (total < 2) {
        dotsEl.hidden = true;
        dotsEl.replaceChildren();
        return;
      }

      dotsEl.hidden = false;

      if (dotsEl.children.length !== total) {
        const frag = document.createDocumentFragment();
        for (let i = 1; i <= total; i += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'zaoud-featured-collection__dot';
          button.setAttribute('aria-label', `Go to page ${i}`);
          button.dataset.page = String(i);
          frag.appendChild(button);
        }
        dotsEl.replaceChildren(frag);
      }

      const current = Math.max(1, parseInt(currentEl.textContent, 10) || 1);
      Array.from(dotsEl.children).forEach((dot, index) => {
        const active = index + 1 === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    dotsEl.addEventListener('click', (event) => {
      const button = event.target.closest('[data-page]');
      if (!button || typeof component.setSlidePosition !== 'function') return;
      if (!component.sliderItemOffset) return;

      const page = parseInt(button.dataset.page, 10);
      if (!page) return;
      component.setSlidePosition((page - 1) * component.sliderItemOffset);
    });

    component.addEventListener('slideChanged', rebuild);
    const observer = new MutationObserver(rebuild);
    observer.observe(currentEl, { characterData: true, childList: true, subtree: true });
    observer.observe(totalEl, { characterData: true, childList: true, subtree: true });

    if (typeof ResizeObserver !== 'undefined' && component.slider) {
      new ResizeObserver(() => {
        if (typeof component.initPages === 'function') component.initPages();
        rebuild();
      }).observe(component.slider);
    }

    rebuild();
  }

  function boot() {
    document.querySelectorAll('[data-zaoud-featured-collection]').forEach(initFeaturedDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-zaoud-featured-collection]');
    if (root) initFeaturedDots(root);
  });
})();
